import React, { Fragment } from 'react'
import { validations } from '../config/siteValidations.js';

export const validate = formName => values => {
    const errors = {};
    for (let field in validations[formName]) {
        let value = values[field];
        errors[field] = validations[formName][field].map(validateField => {
            return validateField(value, values)
        }).find(x => x)
    }
    return errors
};

export const renderField = ({ input, label, placeholder, value, type, className, meta: { touched, error, warning } }) => {
    return (
        <Fragment>
            <div className="control">
                <input {...input} placeholder={placeholder} type={type} className={className} />
                <label className="label">{label}</label>
                {touched &&
                    ((error && <span className="form-error">{error}</span>) || (warning && <span className="form-error">{warning}</span>))}
            </div>
        </Fragment>
    );
};

export const renderCheckBox = ({ input, label, placeholder, value, type, className, meta: { touched, error, warning } }) => {
    return (
        <Fragment>
            <div className="control">
                <input {...input} placeholder={placeholder} type={type} className={className} />
                <label className="label">{label}</label> <br />
                {touched &&
                    ((error && <span className="form-error">{error}</span>) || (warning && <span className="form-error">{warning}</span>))}
            </div>
        </Fragment>
    );
};

export const renderSelect = ({ input, label, className, value, handleChange, defaultValue, meta: { touched, error }, children }) => (

    <div className={className + " field"}>
        {label ? <label className="label">{label}</label> : ""}
        <div className="control">
            <div className={'select ' + (touched ? (error ? 'is-danger' : 'is-success') : '')}>
                <select {...input} className={className} value={defaultValue} onChange={handleChange} >
                    {children}
                </select>
                {touched && (error && <p className="help is-danger">{error}</p>)}
            </div>
        </div>
    </div>
);

export const renderRadio = ({ input, label, placeholder, type, className, checked, meta: { touched, error, warning } }) => (
    <div className={className}>
        <div className="control float-left">
            <input {...input} placeholder={placeholder} type={type} defaultChecked={checked} />
            {touched &&
                ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
        <label className="label float-left">{label}</label>
    </div>
);

export const renderTextarea = ({ input, label, placeholder, type, className, meta: { touched, error, warning } }) => (
    <div className={className}>
        <textarea {...input} placeholder={placeholder} type={type} className={className} />
        <label className="label">{label}</label>
        {touched && ((error && <span className="form-error">{error}</span>) || (warning && <span className="form-error">{warning}</span>))}
    </div>
);



// WEBPACK FOOTER //
// ./src/SHARED/helpers/validation.helper.js